@if (loginSuccess) {
  <div class="flex gap-2 align-items-center justify-content-center pt-3 text-lg">
    <i class="pi pi-face-smile text-xl"></i>
    <span>{{'PLAYER_PROFILE_THANKS_FOR_REGISTRATION' | translate}}</span>
  </div>
  <div class="flex gap-2 align-items-center pt-3 text-lg">
    <b>{{'YOUR_PLAYER_NUMBER' | translate}}:&nbsp;</b>{{authenticateResponse?.playerProfile?.playerNumber ?? '-'}}
  </div>
  <div class="pt-3 pb-4">
    {{'PLAYER_NUMBER_DESCRIPTION' | translate}}
  </div>
  <p-button [label]="'GOTO_PLAYER_PROFILE' | translate"
            icon="pi pi-home" styleClass="grid-comp-full-width" [routerLink]="playerProfileLink"/>
} @else {
  <div>
    <form [formGroup]="form">
      <div class="formgrid grid">
        <div class="field col-12">
          <app-formgrid-label label="LANGUAGE" [mandatory]="true"/>
          <app-language-dropdown [(selectedLanguage)]="languageCd" (languageChange)="changeLanguage()"
                                 [showClear]="false"/>
        </div>

        <div class="field col-12">
          <app-formgrid-label label="CONTACT_EMAILADDRESS" [mandatory]="true"/>
          <app-verify-mail [(mailAddress)]="mailAddress" [(mailConfirmationCode)]="mailConfirmationCode"
                           [baseUrl]="baseUrlMail" [mailReturn]="true"
                           [showMailVerificationTip]="true" showMailVerificationTipColor="text-gray-400"
                           (onVerified)="mailConfirmed = true"
                           (mailAddressChange)="form.controls.mail.patchValue($event)"/>
        </div>
        @if (mailConfirmed) {
          <div class="field col-12 pb-2">
            <app-info-text text="MAIL_ADDRESS_IS_USERNAME_TIP" color="text-gray-400"/>
          </div>
        }
        <div class="field col-12">
          <app-formgrid-label label="PASSWORD" [mandatory]="true"/>
          <p-password id="password" formControlName="password"
                      [placeholder]="'PASSWORD_PLACEHOLDER_MIN_X' | translate: {value: passwordMinLength}"
                      styleClass="p-password-input p-password p-component p-inputwrapper p-input-icon-right"
                      class="grid-comp-full-width" [feedback]="false" [toggleMask]="true"/>
        </div>
        <div class="field col-12">
          <app-formgrid-label label="PASSWORD_RETYPE" [mandatory]="true"/>
          <p-password formControlName="passwordRetype"
                      (keydown.enter)="onOkClicked()"
                      styleClass="p-password-input p-password p-component p-inputwrapper p-input-icon-right"
                      class="grid-comp-full-width" [feedback]="false" [toggleMask]="true"/>
        </div>

        <div class="field col-6 lg:col-4">
          <app-formgrid-label label="PERSON_FIRSTNAME" [mandatory]="true"/>
          <input pInputText type="text" class="p-inputtext w-full" formControlName="firstname" [maxlength]="100">
        </div>
        <div class="field col-6 lg:col-4">
          <app-formgrid-label label="PERSON_LASTNAME" [mandatory]="true"/>
          <input pInputText type="text" class="p-inputtext w-full" formControlName="lastname" [maxlength]="100">
        </div>
        <div class="field col-12 lg:col-4">
          <app-formgrid-label label="LOCATION_COUNTRY" [mandatory]="true"/>
          <app-country-dropdown [(selectedCountryCd)]="countryCd"/>
        </div>
      </div>
    </form>
  </div>

  @if (settings?.daysPremiumRegistration > 0) {
    <div class="pb-2 md:pb-3">
      <app-info-text [text]="system() === 'ios' ? 'PLAYER_PROFILE_FREE_PRO_DAYS_TEXT_IOS' : 'PLAYER_PROFILE_FREE_PRO_DAYS_TEXT' | translate: {value: settings.daysPremiumRegistration}"
                     color="text-gray-300"/>
    </div>
  }

  <div>
    <p-button [label]="'CREATE_FREE_PLAYER_PROFILE' | translate"
              icon="pi pi-check" styleClass="grid-comp-full-width"
              [loading]="isSaving"
              [disabled]="isSaving || form.invalid || !mailConfirmed || form.controls.password.value !== form.controls.passwordRetype.value || !countryCd"
              (onClick)="onOkClicked()"/>
  </div>
}
